import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { getProfileFromAPI } from '../apis/ProfileApi';
import { getFlags } from './featureFlagActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function logout() {
    return {
        type: types.LOG_OUT,
    };
}

export function getCurrentProfile(state) {
    if (state.data && (state.token === window.genesisToken()) && state.token !== '') {
        return {
            type: types.GET_PROFILE_SUCCESS,
            payload: state.data,
        };
    }
    return function (dispatch) {
        return getProfileFromAPI()
            .then((response) => {
                dispatch({
                    type: types.GET_PROFILE_SUCCESS,
                    payload: response.data.data,
                    token: window.genesisToken(),
                });
                localStorage.setItem('OrganizationId', response.data.data.organizationId);
                localStorage.setItem('GivingChurchId', response.data.data.givingChurchId);
                dispatch(getFlags(response.data.data.organizationId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROFILE_FAILED);
            });
    };
}
